import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from 'react/components/Modal';
import { getResourceTo } from 'react/utils/utils';
import { LookupField, GroupField, TextField } from 'react/components/fields';

const OrganizationFieldsModal = ({ closeModalFn, modalIsOpen }) => {
  const buttonLabel = getResourceTo('samlConfiguration.button.close');
  const organizationModalSubtitle = getResourceTo(
    'organizationMappingModal.label.subtitle'
  );
  const Footer = () => (
    <>
      <input type="button" value={buttonLabel} onClick={closeModalFn} />
    </>
  );

  return (
    <Modal
      className="fieldMappingModal"
      isOpen={modalIsOpen}
      title={Monet.I18n.getResourcesByKey(
        'organizationMappingModal.label.title'
      )}
      closeModalFn={closeModalFn}
      crossAxisBtn={false}
      footer={<Footer />}
    >
      <p className="fieldMappingModal-label">{organizationModalSubtitle}</p>
      <GroupField name="idp.organizationMappings">
        <TextField
          label="samlConfiguration.identityProviderOrganization"
          description="assertionFieldName"
          name="assertionFieldName"
        />
        <div className="arrowRight" />
        <LookupField
          label="samlConfiguration.greenmileOrganization"
          name="value"
          lookupEntity="Organization"
          lookupEntityColumn="description"
        />
      </GroupField>
    </Modal>
  );
};

OrganizationFieldsModal.propTypes = {
  closeModalFn: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  modalIsOpen: state.samlConfiguration.getIn(
    ['modals', 'organization', 'modalIsOpen'],
    false
  )
});

export default connect(mapStateToProps)(React.memo(OrganizationFieldsModal));
